import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import RegistrationHeader from "../../components/registration/RegistrationHeader";
import { useRegistrationData } from "../../utils/registrationUtils";
import { DetailsBox } from "../../components/DetailsComponent";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getItemInLocalStorage } from "../../services/localStorage";
import { Button } from "../../common/components/Button";
import backarrowIcon from "../../assets/images/back-arrow-icon.svg";
import { format } from "date-fns";
import calender from "../../assets/images/calendar.svg";
import locationlogo from "../../assets/images/locationlogo.svg";
import { getCall } from "../../services/apiService";
import Loader from "../../common/components/Loader";
import { Tooltip } from "@mui/material";
function groupQuestionsBySection(apiData: any[]): Record<
  number,
  {
    sectionName: string;
    answers: {
      questionId: number;
      label: string;
      answer: string;
      type?: string;
    }[];
  }
> {
  const grouped: Record<
    number,
    {
      sectionName: string;
      answers: {
        questionId: number;
        label: string;
        answer: string;
        type?: string;
      }[];
    }
  > = {};

  apiData.forEach((item) => {
    const sectionId = item.sectionId;
    if (!grouped[sectionId]) {
      grouped[sectionId] = {
        sectionName: item.sectionName,
        answers: [],
      };
    }
    grouped[sectionId].answers.push({
      questionId: item.questionId,
      label: item.questionLabel,
      answer: item.answer,
      type: item.questionType == "file" ? (item?.config?.filetype == "video" ? "video" : item.questionType)  : item.questionType,
    });
  });

  // Add section 4 questions to section 1, but do NOT render section 4 as a separate card
  if (grouped[1] && grouped[4]) {
    grouped[1].answers = [...grouped[1].answers, ...grouped[4].answers];
    delete grouped[4];
  }

  return Object.values(grouped);
}

const SummaryPage = () => {
  const [searchParams] = useSearchParams();
  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};
  const programId = searchParams.get("programId");
  const navigate = useNavigate();

  const {
    loading,
    error,
    programDetails,
    groupedAnswersData,
    userStatus,
    groupedQuestions,
    refetch,
  } = useRegistrationData(programId || "", seekerDetails.id);

  const [sectionData, setSectionData] = useState<
    Record<
      number,
      {
        sectionName: string;
        answers: {
          questionId: number;
          label: string;
          answer: string;
          type?: string;
        }[];
      }
    >
  >({});

  useEffect(() => {
    const registrationId = userStatus?.id;
    if (registrationId) {
      getCall(`registration/${registrationId}/questions`, undefined, false)
        .then((response) => {
          // If your API response is { data: [...] }
          const apiData = response?.data.data || [];
          console.log("API Data:", apiData);
          const grouped = groupQuestionsBySection(apiData);
          setSectionData(grouped);
          //   console.log("Questions API response:", response);
        })
        .catch((error) => {
          console.error("Questions API error:", error);
        });
    }
  }, [userStatus?.id]);
  console.log("Section Data:", sectionData);

  if (loading) return <Loader type="large" />;
  if (error) return <div>Error loading data.</div>;

  const venue = programDetails?.venue || programDetails?.type?.venue || "-";
  const startDate = programDetails?.startsAt || programDetails?.checkinAt;
  const endDate = programDetails?.endsAt || programDetails?.checkoutAt;

  // Format date/time
  let dateTime = "-";
  if (startDate && endDate) {
    try {
      const start = new Date(startDate);
      const end = new Date(endDate);
      dateTime = `${format(start, "dd MMM yyyy")} - ${format(end, "dd MMM yyyy")}`;
    } catch {
      dateTime = "-";
    }
  }
  const handleDragAndDropValue = (answer: string) => {
    try {
      const pref = JSON.parse(decodeURIComponent(answer));
      console.log("Decoded drag and drop value:", pref);
      return pref; // Return the JSON object
    } catch (e) {
      console.error("Invalid drag and drop value", e);
      return answer;
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src={backarrowIcon}
          alt="back arrow"
          className={styles.backArrow}
          onClick={() => navigate("/infinipath/list")}
        />
        <span className={styles.headerTitle}>Summary</span>
      </div>
      <div className={styles.formSection}>
        <div className={styles.content}>
          <h2 className={styles.heading}>Congratulations!</h2>
          <p className={styles.subHeading}>
            You’re officially on boarded for{" "}
            {userStatus?.allocatedProgram?.name}.
          </p>
        </div>
        <div className={styles.calendarContainer}>
          <div className={styles.sectionHeader}>
            <div className={styles.banner}>
              <RegistrationHeader />
            </div>
          </div>
        </div>
        <div className={styles.eventInfoBox}>
          <div className={styles.eventItem}>
          <img
              src={locationlogo}
              alt="location"
              className={styles.eventIcon}
            />
            {venue &&
              venue?.length > 40 ? (
              <Tooltip title={venue} arrow placement="top">
                <span>
                  {venue?.slice(0, 40)}
                  {"..."}
                </span>
              </Tooltip>
            ) : (
              venue
            )}
          </div>
          <div className={styles.eventItem}>
            <img src={calender} alt="calendar" className={styles.eventIcon} />
            <span>{dateTime}</span>
          </div>
        </div>
        <div>
          {Object.values(sectionData).map((section, idx) => (
            <DetailsBox
              key={section.sectionName}
              cardTitle={section.sectionName}
              fields={section.answers.map((ans) => {
                let value = ans.answer;
                let type = ans.type === "file" ? "file" : ans.type || "string";

                return {
                  label: ans.label,
                  value,
                  type,
                };
              })}
              fieldsPerRow={2}
            />
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <Button
            onClick={() => navigate("/infinipath/list")}
            buttonClassName={styles.confirmButton}
            buttonTextClassName={styles.confirmText}
          >
            done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPage;
